import { FabriqIdbStorage } from "@/classes/FabriqIdbStorage";

const storage = new FabriqIdbStorage();

export default storage;
